// extracted by mini-css-extract-plugin
module.exports = {"green":"TFBIcon_green__3kYZY","white":"TFBIcon_white__2iPpK","black":"TFBIcon_black__3-D0t","gray":"TFBIcon_gray__2PjxF","red":"TFBIcon_red__1JlxL"};